import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

const StructuredData = ({ blok }) => (
  <Helmet>
    <script type="application/ld+json">{blok.json}</script>
  </Helmet>
)

StructuredData.propTypes = {
  blok: PropTypes.shape({
    json: PropTypes.string,
  }).isRequired,
}

export default StructuredData
